'use client';

import { Skeleton } from "../ui/skeleton";

export default function PostsSkeleton() {
  // Create an array of 6 items to render 6 skeleton cards
  const skeletonItems = Array.from({ length: 6 }, (_, i) => i);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {skeletonItems.map((item) => (
        <div key={item} className="bg-white rounded-md shadow-sm overflow-hidden border border-gray-100">
          {/* Skeleton for featured image */}
          <Skeleton className="w-full h-48" />
          
          {/* Skeleton for content */}
          <div className="p-4">
            {/* Skeleton for title */}
            <Skeleton className="h-6 w-full mb-2" />
            <Skeleton className="h-6 w-3/4 mb-4" />
            
            {/* Skeleton for date */}
            <Skeleton className="h-4 w-1/3" />
          </div>
        </div>
      ))}
    </div>
  );
}
